<style lang="scss">
  @import './index.scss';

.trend .ivu-checkbox {
  margin-right: 4px;
}
</style>
<template>
  <div class="trend">
    <!-- 顶部指标 -->
    <div class="overview">
      <h1>{{$t('trend.overview.title')}}</h1>
      <Row>
        <i-col>
          <div class="overview-box">
            <div class="overview-num">
              {{num.newuser | numberSeparator}}
            </div>
            <div class="overview-equipment">
              <i v-if="getNewAddPro!=='--'" class="iconfont" :class="Number(getNewAddPro) !== 0 ? (getNewAddPro > 0 ? 'icon-rise' : 'icon-drop'):'icon-equal'"></i>
              <i v-else class="iconfont"></i>
              <span v-if="getNewAddPro==='--'" class="overview-equ"></span>
              <span v-else class="overview-equ">{{getNewAddPro}}%</span>
            </div>
          </div>
          <div class="overview-name">
            <Tooltip>
              {{$t('trend.overview.newuser')}}
              <div slot="content">
                {{$t('trend.overview.explain.a')}}
              </div>
            </Tooltip>
          </div>
        </i-col>
        <i-col>
          <div class="overview-box">
            <div class="overview-num">
              {{num.launchuser | numberSeparator}}
            </div>
            <div class="overview-equipment">
              <i v-if="getLaunchuserPro!=='--'" class="iconfont" :class="Number(getLaunchuserPro) !== 0 ? (getLaunchuserPro > 0 ? 'icon-rise' : 'icon-drop'):'icon-equal'"></i>
              <i v-else class="iconfont"></i>
              <span v-if="getLaunchuserPro==='--'" class="overview-equ"></span>
              <span v-else class="overview-equ">{{getLaunchuserPro}}%</span>
            </div>
          </div>
          <div class="overview-name">
            <Tooltip>
              {{$t('trend.overview.launchuser')}}
              <div slot="content">
                {{$t('trend.overview.explain.b')}}
              </div>
            </Tooltip>
          </div>
        </i-col>
        <i-col>
          <div class="overview-box">
            <div class="overview-num">
              {{getDAUMAU}}
            </div>
          </div>
          <div class="overview-name">
            <Tooltip>
              {{$t('trend.overview.launchpro')}}
              <div slot="content">
                {{$t('trend.overview.explain.c')}}
              </div>
            </Tooltip>
          </div>
        </i-col>
        <i-col>
          <div class="overview-box">
            <div class="overview-num">
              {{num.startup | numberSeparator}}
            </div>
            <div class="overview-equipment">
              <i v-if="getStartupPro!=='--'" class="iconfont" :class="Number(getStartupPro) !== 0 ? (getStartupPro > 0 ? 'icon-rise' : 'icon-drop'):'icon-equal'"></i>
              <i v-else class="iconfont"></i>
              <span v-if="getStartupPro==='--'" class="overview-equ"></span>
              <span v-else class="overview-equ">{{getStartupPro}}%</span>
            </div>
          </div>
          <div class="overview-name">
            <Tooltip>
              {{$t('trend.overview.startup')}}
              <div slot="content">
                {{$t('trend.overview.explain.d')}}
              </div>
            </Tooltip>
          </div>
        </i-col>
        <i-col>
          <div class="overview-box">
            <div class="overview-num">
              {{getSingleUsetime}}
            </div>
            <div class="overview-equipment">
              <i v-if="getSingleUsetimePro!=='--'" class="iconfont" :class="Number(getSingleUsetimePro) !== 0 ? (getSingleUsetimePro > 0 ? 'icon-rise' : 'icon-drop'):'icon-equal'"></i>
              <i v-else class="iconfont"></i>
              <span v-if="getSingleUsetimePro==='--'" class="overview-equ"></span>
              <span v-else class="overview-equ">{{getSingleUsetimePro}}%</span>
            </div>
          </div>
          <div class="overview-name">
            <Tooltip>
              {{$t('trend.overview.onetime')}}
              <div slot="content">
                {{$t('trend.overview.explain.e')}}
              </div>
            </Tooltip>
          </div>
        </i-col>
      </Row>
    </div>
    <!-- 图表部分 -->
    <div class="trend-view">
      <!-- 图表标题 -->
      <Row class="trend-view-title trend-view-title-border">
        <i-col span="16" class="trend-view-title-h3">{{ $t('trend.title') }}</i-col>
        <i-col span="8">
          <div class="event-details-view-date" style="top: 0">
            <Checkbox v-model="openDiff" @on-change="diffClear">{{ $t('eventdetails.diffdate') }}</Checkbox>
            <!--日期选择-->
            <Date-picker
              type="date"
              :disabled="openDiff"
              confirm
              placement="bottom-end"
              :open="datePickerOpen"
              :options="dateOption"
              :placeholder="$t('filter.choose')"
              style="width: 200px; display:inline-block;"
              :value="selectedDate"
              @on-change="changeContrast"
              @on-clear="clearContrast"
              @on-ok="contrastDate">
              <a v-show="openDiff" href="javascript:void(0)"
                 @click="toggleDatePicker"
                 class="event-details-view-date-ctrl">
                <Icon type="md-calendar"></Icon>
                <span class="filter-content">
                                <strong v-if="selectedDate == ''">{{ $t('eventdetails.diffdate') }}</strong>
                                <strong v-else>{{ selectedDate }}</strong>
                            </span>
                <Icon style="float:right;" type="ios-arrow-down"></Icon>
              </a>
            </Date-picker>
          </div>
        </i-col>
      </Row>
      <!-- 图表内容 -->
      <Tabs @on-click="setChartData">
        <Tab-pane :label="$t('trend.newuser.name')" name="newuser">
          <chart-move ref="newuser">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.newuser.total') }}</span><b>{{ newuser.userTotal | numberSeparator }}</b>
              </div>
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.newuser.average') }}</span><b>{{ newuser.userAverage | numberSeparator }}</b>
              </div>
              <div v-if="watchDataShow" class="analytics-metrice-title">
                <span>{{ $t('trend.newuser.watch-total') }}</span><b>{{ newuser.watchTotal | numberSeparator }}</b>
              </div>
              <div v-if="watchDataShow" class="analytics-metrice-title">
                <span>{{ $t('trend.newuser.watch-average') }}</span><b>{{ newuser.watchAverage | numberSeparator }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
        <Tab-pane :label="$t('trend.launchuser.day')" name="launchuser">
          <chart-move ref="launchuser">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.total') }}</span><b>{{ launchuser.userTotal | numberSeparator }}</b>
              </div>
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.average') }}</span><b>{{ launchuser.userAverage | numberSeparator }}</b>
              </div>
              <div v-if="watchDataShow" class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.watch-total') }}</span><b>{{ launchuser.watchTotal | numberSeparator }}</b>
              </div>
              <div v-if="watchDataShow" class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.watch-average') }}</span><b>{{ launchuser.watchAverage | numberSeparator }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
        <Tab-pane :label="$t('trend.launchuser.week')" name="week">
          <chart-move ref="week">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.average') }}</span><b>{{ week.userAverage | numberSeparator }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
        <Tab-pane :label="$t('trend.launchuser.month')" name="month">
          <chart-move ref="month">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.launchuser.average') }}</span><b>{{ month.userAverage | numberSeparator }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
        <Tab-pane :label="$t('trend.startup.name')" name="startup">
          <chart-move ref="startup">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.startup.average') }}</span><b>{{ startup.userAverage | numberSeparator }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
        <Tab-pane :label="$t('trend.onetime.name')" name="onetime">
          <chart-move ref="onetime">
            <div slot="chart-move-metrice">
              <div class="analytics-metrice-title">
                <span>{{ $t('trend.onetime.average') }}</span><b>{{ getSingleUsetime }}</b>
              </div>
            </div>
          </chart-move>
        </Tab-pane>
      </Tabs>
    </div>
    <!-- 表格部分 -->
    <div class="trend-view">
      <!-- 表格标题及按钮 -->
      <Row class="trend-view-title">
        <!-- 表格标题 -->
        <i-col :xs='18' :sm='19' :md='20' :lg='21' class="trend-view-title-h3">{{ $t('trend.table') }}</i-col>
        <!-- 下载按钮及指标说明 -->
        <i-col :xs='6' :sm='5' :md='4' :lg='3' class="trend-view-title-details">
          <span class="iconfont icon-download tm-icon-font hover-style" @click="exportData"></span>
          <Poptip trigger="hover" class="trend-view-title-notab-pop" placement="bottom-end">
            <span class="iconfont icon-help tm-icon-font hover-style" style="margin-left:10px;"></span>
            <div slot="title">{{ $t('portrait.indexInfo') }}</div>
            <div slot="content">
              <p><span>{{ $t('trend.newuser.name') }}</span>{{ $t('trend.index.a') }}</p>
              <p class="bg"><span>{{ $t('trend.launchuser.day') }}</span>{{ $t('trend.index.b') }}</p>
              <p><span>{{ $t('trend.launchuser.week') }}</span>{{ $t('trend.index.c') }}</p>
              <p class="bg"><span>{{ $t('trend.launchuser.month') }}</span>{{ $t('trend.index.d') }}</p>
              <p><span>{{ $t('trend.startup.name') }}</span>{{ $t('trend.index.e') }}</p>
              <p class="bg"><span>{{ $t('trend.onetime.name') }}</span>{{ $t('trend.index.f') }}</p>
            </div>
          </Poptip>
        </i-col>
      </Row>
      <!-- 表格内容 -->
      <table-move ref="trend-table"></table-move>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import numberToTime from '../../filters/number-to-time';
  import percent from '../../filters/percent-formate';
  import numberSeparator from '../../filters/number-separator';
  import dateToTime from '../../filters/date-to-time';
  import chartMove from '../../components/app-overview/chart-move';
  import tableMove from '../../components/app-overview/table-move';
  import util from '../../libs/util';
  import bus from '../../libs/bus';
  import ln from '../../libs/locale';

  export default {
    name: 'index',
    data() {
      return {
        num: {
          total: '--',
          pretotal: '--',
          newuser: '--',
          preNewuser: '--',
          launchuser: '--',
          preLaunchuer: '--',
          startup: '--',
          preStartup: '--',
          usetime: '--',
          preUsetime: '--',
        },
        dayLaunchuserList: [], // 所选时间段内日活设备
        mounthLaunchuserList: [], // 所选时间段内每天月活设备
        newuser: {
          show: false,
          userTotal: '--',
          watchTotal: '--',
          userAverage: '--',
          watchAverage: '--',
        },
        launchuser: {
          show: false,
          userTotal: '--',
          watchTotal: '--',
          userAverage: '--',
          watchAverage: '--',
        },
        week: {
          show: false,
          userAverage: '--',
        },
        month: {
          show: false,
          userAverage: '--',
        },
        startup: {
          show: false,
          userAverage: '--',
        },
        onetime: {
          show: false,
          userAverage: '--',
        },
        trendTable: {
          show: false,
        },
        initUser: 'newuser', // 图表当前展示的 Tab
        monthTotal: 0, // 月活跃总数
        weekTotal: 0, // 周活跃总数
        weekChartData: [], // 存储周活跃图表数据
        monthChartData: [], // 存储月活跃图表数据
        // 取消请求
        source: axios.CancelToken.source(),
        openDiff: false,
        datePickerOpen: false,
        selectedDate: '', //对比时间的选中
        dateOption: {
          disabledDate(date) {
            // 控制时间段，当前应用接入 analytics之前的时间段禁选、今天之后的日期禁选
            const registertime = bus.productInfo.registertime;
            const appRegistertime = registertime ? registertime.replace(/-/g, '/') : '2011/01/01';
            // eslint-disable-next-line
            return date && (date.valueOf() > Date.now() || date.valueOf() < Date.parse(appRegistertime) - 24*3600*1000);
          },
          shortcuts: [
            {
              text: this.$t('filter.week'),
              onClick: () => {
                this.contrastDate(7);
              },
            },
            {
              text: this.$t('filter.month'),
              onClick: () => {
                this.contrastDate(30);
              },
            },
            {
              text: this.$t('filter.cancel'),
              onClick: () => {
                this.clearContrast();
              },
            },
          ],
        },
        changeDateNumber: 0, // 日期切换的天数
      };
    },
    components: {
      chartMove,
      tableMove,
    },
    filters: {
      numberSeparator,
      numberToTime,
      dateToTime,
      percent,
    },
    computed: {
      /**
       * 判断是否展示 watch数据
       * 当查询的平台存在 ios平台，并且用户开启 watch数据展示功能
       */
      watchDataShow() {
        const len = bus.platform.filter(v => v.toString() === '2').length > 0;
        return bus.productInfo.watchshow === 0 && len;
      },
      getNewAddPro() {
        // 求新增设备增长率
        const n = (((this.num.newuser - this.num.preNewuser) / this.num.preNewuser) * 100).toFixed(2);
        const value = this.num.newuser !== '--' ? n : '--';
        return value === 'NaN' || value === 'Infinity' ? '--' : value;
      },
      getLaunchuserPro() {
        // 求活跃设备增长率
        const per = this.num.preLaunchuer;
        const n = (((this.num.launchuser - per) / per) * 100).toFixed(2);
        const value = this.num.launchuser !== '--' ? n : '--';
        return value === 'Infinity' || value === 'NaN' ? '--' : value;
      },
      getDAUMAU() {
        // 求日活/月活
        let value = '--';
        if (this.mounthLaunchuserList.length > 0) {
          let num = 0;
          const len = this.mounthLaunchuserList.length;
          for (let i = 0; i < len; i++) {
            num += this.dayLaunchuserList[i].launchuser === 0 ?
              0 : this.dayLaunchuserList[i].launchuser / this.mounthLaunchuserList[i].month;
          }
          value = (num / len).toFixed(2);
        }
        return value === 'NaN' || value === 'Infinity' ? '--' : value;
      },
      getStartupPro() {
        // 求启动次数增长率
        const n = (((this.num.startup - this.num.preStartup) / this.num.preStartup) * 100).toFixed(2);
        const value = this.num.startup !== '--' ? n : '--';
        return value === 'NaN' || value === 'Infinity' ? '--' : value;
      },
      getSingleUsetime() {
        // 求单次使用时长
        const n = this.num.usetime === '--' ?
          '--' : numberToTime(Math.round(this.num.usetime / this.num.startup));
        return n;
      },
      getSingleUsetimePro() {
        // 求单次使用时长增长率
        const val1 = this.num.usetime / this.num.startup;
        const val2 = this.num.preUsetime / this.num.preStartup;
        const value = this.num.usetime !== '--' ? (((val1 - val2) / val2) * 100).toFixed(2) : '--';
        return value === 'NaN' || value === 'Infinity' ? '--' : value;
      },
    },
    // fix compiled
    mounted() {
      const self = this;
      bus.$on('on-app-change', () => {
        self.initNum();
        self.init();
      });
      bus.$on('on-platform-change', () => {
        self.initNum();
        self.init();
      });
      bus.$on('on-conditions-change', () => {
        self.initNum();
        self.init();
      });
      bus.$on('on-date-change', () => {
        self.initNum();
        self.init();
      });
      if (!bus.productInfo.productid) {
        return;
      }
      self.initNum();
      self.init();
    },
    beforeDestroy() {
      bus.$off('on-app-change');
      bus.$off('on-platform-change');
      bus.$off('on-conditions-change');
      bus.$off('on-date-change');
      // 清除之前请求
      this.source.cancel('clear request');
    },
    methods: {
      init() {
        const self = this;
        // 求日历选中时间段的各参数
        self.getOverviewNum(
          ['totaluser', 'newuser', 'launchuser', 'startup', 'usetime'],
          bus.selectedDate[0],
          bus.selectedDate[1],
        );
        // 求上个时间段的各参数
        self.getOverviewNum(
          ['newuser', 'totaluser', 'launchuser', 'startup', 'usetime'],
          self.getDay(bus.selectedDate[0],
            dateToTime(bus.selectedDate)),
          self.getDay(bus.selectedDate[0], -1),
        );
        // 清除之前请求
        self.source.cancel('clear request');
        // 创建新的token
        self.source = axios.CancelToken.source();
        // for (const item of Object.keys(self.$refs)) {
        //   self.$refs[item].clearData();
        // }
        Object.keys(self.$refs).forEach((item) => {
          self.$refs[item].clearData();
        });
        self.clearData();
        self.clearContrast();
        self.setChartData(self.initUser);
        self.getTableData();
      },
      initNum() {
        this.num.total = '--';
        this.num.pretotal = '--';
        this.num.newuser = '--';
        this.num.preNewuser = '--';
        this.num.launchuser = '--';
        this.num.preLaunchuer = '--';
        this.num.startup = '--';
        this.num.preStartup = '--';
        this.num.usetime = '--';
        this.num.preUsetime = '--';
        this.dayLaunchuserList = [];
        this.mounthLaunchuserList = [];
      },
      getDay(date, days) { // date:日期yyyy-mm-dd，days：距离date天数
        const today = new Date(date).valueOf();
        const selday = new Date(today + (days * 3600 * 1000 * 24));
        const year = selday.getFullYear();
        const oMonth = selday.getMonth() + 1;
        const month = oMonth >= 10 ? oMonth : `0${oMonth}`;
        const day = selday.getDate() >= 10 ? selday.getDate() : `0${selday.getDate()}`;
        return `${year}-${month}-${day}`;
      },
      // 请求数据的开始时间距离今天的天数
      getDays(start) {
        const time = [start, bus.getDay(0)];
        const days = dateToTime(time) + 1;
        return days;
      },
      /**
       * 获取顶部指标数据的请求
       * @param  {[Array]} metric    [要获取得数据指标名称集合]
       * @param  {[String]} startTime [起始时间]
       * @param  {[String]} endTime   [结束时间]
       */
      getOverviewNum(metric, startTime, endTime) {
        const self = this;
        const group = 'productid';
        util.ajax.post('/app/rest/data.json/query', {
          metrics: metric,
          groupby: group,
          conditions: {
            developerid: bus.developerid,
            productid_list: [bus.productInfo.productid],
            platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
            partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
            usergroup_list: bus.conditions.usergroup.length === 0 ?
              undefined :
              bus.conditions.usergroup,
            version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
            start: startTime,
            end: endTime,
          },
          start: startTime,
        }).then((res) => {
          // 根据metric[0]判断是选中时间段or同比上个时间段,‘total’时为日历选中时段
          const time = -(dateToTime(bus.selectedDate));
          if (metric[0] === 'totaluser') {
            self.num.total = res[0].total;
            self.newuser.userTotal = res[0].newuser;
            self.num.newuser = res[0].newuser;
            self.newuser.userAverage = percent(this.num.newuser / time);
            self.launchuser.userTotal = res[0].launchuser;
            self.num.launchuser = res[0].launchuser;
            self.launchuser.userAverage = percent(this.num.launchuser / time);
            self.num.startup = res[0].startup;
            self.num.usetime = res[0].usetime;
          } else if (metric[0] === 'newuser') {
            self.num.pretotal = res[0].total;
            self.num.preNewuser = res[0].newuser;
            self.num.preLaunchuer = res[0].launchuser;
            self.num.preStartup = res[0].startup;
            self.num.preUsetime = res[0].usetime;
          }
        });
      },
      /**
       * 单指标数据请求
       * @param  {[String]} str      [数据指标名称]
       * @param  {[String]} platform [请求的平台信息]
       */
      getMetrics(str, date, platform) {
        const id = platform || (bus.isAllPlatform ? '' : bus.platform.toString());
        return util.ajax.post('/app/rest/data.json/query', {
          metrics: [str],
          groupby: 'day',
          conditions: {
            developerid: bus.developerid,
            productid_list: [bus.productInfo.productid],
            platformid: id,
            start: date.selectedDate[0],
            end: date.selectedDate[1],
            version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
            usergroup_list: bus.conditions.usergroup.length === 0 ?
              undefined : bus.conditions.usergroup,
            partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          },
        });
      },
      getMetricsWatch(str) {
        // const id = platform || bus.platform.toString();
        return util.ajax.post('/app/rest/data.json/query', {
          metrics: [str],
          groupby: 'productid',
          conditions: {
            developerid: bus.developerid,
            productid_list: [bus.productInfo.productid],
            platformid: '8',
            start: bus.selectedDate[0],
            end: bus.selectedDate[1],
            version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
            usergroup_list: bus.conditions.usergroup.length === 0 ?
              undefined : bus.conditions.usergroup,
            partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          },
        });
      },
      /**
       * 周活跃月活跃数据请求
       * @param  {[String]} user [数据请求表示]
       * @param  {[Number]} i    [起始时间距离今天的天数]
       * @param  {[Number]} k    [数据对应索引值]
       * @param  {[Number]} d    [请求多少天的数据]
       * @param  {[Boolean]} isComparison  [是否是对比数据]
       */
      getLaunch(user, i, k, d, isComparison) {
        this.$refs[user].spinShow = true;
        const num = user === 'week' ? 6 : 29;
        const arg = user === 'week' ? 'weekChartData' : 'monthChartData';
        const total = user === 'week' ? 'weekTotal' : 'monthTotal';
        util.ajax.post('/app/rest/data.json/query', {
          metrics: ['launchuser'],
          groupby: 'productid',
          conditions: {
            developerid: bus.developerid,
            productid_list: [bus.productInfo.productid],
            platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
            start: bus.getDay(i - num),
            end: bus.getDay(i),
            version_list: bus.conditions.version.length === 0 ? undefined : bus.conditions.version,
            usergroup_list: bus.conditions.usergroup.length === 0 ?
              undefined :
              bus.conditions.usergroup,
            partnerid_list: bus.conditions.partner.length === 0 ? undefined : bus.conditions.partner,
          },
        }, {
          cancelToken: this.source.token,
        }).then((res) => {
          /*
          ** 递归请求活跃数据
          ** 计算活跃total值
          ** 图表数据
          **/
          if (k + 1 > d) {
            this[user].userAverage = percent(this[total] / k);
            const chartData = {
              [user]: this[arg],
            };
            if (chartData.month) {
              this.mounthLaunchuserList = chartData.month;
            }
            this[user].show = true;
            if (isComparison && this.openDiff && this.selectedDate) {
              this.diffChartData(chartData[user], user);
            } else {
              this.$refs[user].setChartsData(chartData, 'day', user); // 周、月活跃折线图
            }
          } else {
            this.getLaunch(user, i + 1, k + 1, d, isComparison);
            this[total] += res[0].launchuser;
            const obj = {
              day: bus.getDay(i),
              [user]: res[0].launchuser,
            };
            this.$set(this[arg], k, obj);
            if (!isComparison) {
              this.$refs['trend-table'].setData(k, bus.getDay(i), res[0].launchuser, user);
            }
          }
        }).catch((thrown) => {
          // 如果出现2017、2018跨年的异常，继续请求之后不跨年的周活、月活
          if (thrown && thrown.response && thrown.response.status === 422) {
            if (k + 1 > d) {
              this[user].userAverage = percent(this[total] / k);
              const chartData = {
                [user]: this[arg],
              };
              if (chartData.month) {
                this.mounthLaunchuserList = chartData.month;
              }
              this[user].show = true;
              if (isComparison && this.openDiff && this.selectedDate) {
                this.diffChartData(chartData[user], user);
              } else {
                this.$refs[user].setChartsData(chartData, 'day', user); // 周、月活跃折线图
              }
            } else {
              this.getLaunch(user, i + 1, k + 1, d, isComparison);
              this[total] += 0;
              const obj = {
                day: bus.getDay(i),
                [user]: 0,
              };
              this.$set(this[arg], k, obj);
            }
          }
          if (axios.isCancel(thrown)) {
            // 请求取消
          }
        });
      },
      /**
       * Tab切换触发对应表格列数据高亮
       * @param {[String]} str [当前图表标示]
       */
      setChartData(str) {
        const self = this;
        self.initUser = str;
        const s = str === 'launchuser' ? 'daylaunchuser' : str;
        self.$refs['trend-table'].changeColumnColor(s);
      },
      /**
       * 计算图表数据总值，均值
       * @param  {[String]} str       [图表标示]
       * @param  {[Array]} data      [图表展示的数据]
       * @param  {[Array]} watchData [Watch数据](可选)
       */
      countData(str, data) {
        const self = this;
        const time = -(dateToTime(bus.selectedDate));
        if (str !== 'launchuser' && str !== 'newuser') {
          let total = 0;
          for (let item = 0; item < data.length; item++) {
            total += (data[item][str]) * 1;
          }
          self[str].userAverage = str === 'onetime' ?
            Math.round(total / time) : percent(total / time);
        }
      },
      // 获取表格数据
      getTableData() {
        const self = this;
        const tendTable = self.$refs['trend-table'];
        // 表格表头处理，是否展示 watch数据
        const res = self.watchDataShow ? [
          'newuser',
          'newwatch',
          'daylaunchuser',
          'launchwatch',
          'week',
          'month',
          'startup',
          'onetime',
        ] : [
          'newuser',
          'daylaunchuser',
          'week',
          'month',
          'startup',
          'onetime',
        ];
        tendTable.setColumn(res, self.initUser);
        // 请求处理 是否请求 watch数据
        const newuserUrl = self.watchDataShow ? [
          self.getMetrics('newuser', bus),
          self.getMetrics('newuser', bus, '8'),
        ] : [self.getMetrics('newuser', bus)];
        const launchuserUrl = self.watchDataShow ? [
          self.getMetrics('launchuser', bus),
          self.getMetrics('launchuser', bus, '8'),
        ] : [self.getMetrics('launchuser', bus)];
        if (self.watchDataShow) {
          let watchtotals = 0;
          const time = -(dateToTime(bus.selectedDate));
          //请求新增watch
          self.getMetricsWatch('newuser').then((newW) => {
            watchtotals = newW[0].newuser * 1;
            self.newuser.watchTotal = watchtotals;
            self.newuser.watchAverage = percent(watchtotals / time);
          });
          //请求活跃watch去重数据
          self.getMetricsWatch('launchuser').then((newW) => {
            watchtotals = newW[0].launchuser * 1;
            self.launchuser.watchTotal = watchtotals;
            self.launchuser.watchAverage = percent(watchtotals / time);
          });
        }
        // 请求新增数据
        axios.all(newuserUrl).then(axios.spread((newRes, newWatch) => {
          const tabledata = newRes;
          if (newWatch) {
            for (let i = 0; i < tabledata.length; i++) {
              for (let j = 0; j < newWatch.length; j++) {
                if (tabledata[i].day === newWatch[j].day) {
                  tabledata[i].newwatch = newWatch[j].newuser;
                }
              }
            }
          }
          const chartData = self.watchDataShow ? {
            name: newRes,
            watch: newWatch,
          } : { name: newRes };
          self.countData('newuser', newRes);
          self.changeChart(chartData, 'newuser'); // 新增折线图
          tendTable.setTableData(res, tabledata, 'table');
          // 请求活跃用户
          axios.all(launchuserUrl).then(axios.spread((launch, launchWatch) => {
            const launchdata = launch;
            this.dayLaunchuserList = launch;
            if (launchWatch) {
              const table = JSON.parse(tendTable.saveTableData);
              for (let i = 0; i < table.length; i++) {
                for (let j = 0; j < launchdata.length; j++) {
                  if (table[i].day === launchdata[j].day) {
                    table[i].daylaunchuser = launchdata[j].launchuser;
                  }
                }
                for (let k = 0; k < launchWatch.length; k++) {
                  if (table[i].day === launchWatch[k].day) {
                    table[i].launchwatch = launchWatch[k].launchuser;
                  }
                }
              }
              tendTable.saveTableData = JSON.stringify(table);
              tendTable.changeData = table;
              tendTable.tableData = tendTable.mockTableData(1, table);
            } else {
              for (let j = 0; j < launchdata.length; j++) {
                launchdata[j].daylaunchuser = launchdata[j].launchuser;
              }
              self.changeTable(launchdata, 'daylaunchuser');
            }
            const launchuserChart = self.watchDataShow ? {
              name: launch,
              watch: launchWatch,
            } : { name: launch };
            self.countData('launchuser', launch);
            self.changeChart(launchuserChart, 'launchuser'); // 活跃折线图
          }));
          // 请求启动次数
          // self.getMetrics('startup', bus).then((startRes) => {
          //   const startChart = {
          //     name: startRes,
          //   };
          //   self.countData('startup', startRes);
          //   self.changeChart(startChart, 'startup');
          //   self.changeTable(startRes, 'startup'); // 启动次数折线图
          // });
          // 启动次数、单次使用时长 = 使用时长/启动次数
          axios.all([
            self.getMetrics('startup', bus), // 启动次数
            self.getMetrics('usetime', bus), // 使用时长
          ]).then(axios.spread((start, timeRes) => {
            // 启动次数
            const startChart = {
              name: start,
            };
            self.countData('startup', start);
            self.changeChart(startChart, 'startup');
            self.changeTable(start, 'startup'); // 启动次数折线图
            // 单次使用时长
            const times = [];
            for (let i = 0; i < start.length; i++) {
              for (let j = 0; j < timeRes.length; j++) {
                const averageTime = start[i].startup === 0 ?
                  0 : Math.round(timeRes[j].usetime / start[i].startup);
                if (timeRes[j].day === start[i].day) {
                  times[i] = {
                    day: start[i].day,
                    onetime: averageTime,
                  };
                }
              }
            }
            const onetimeChart = {
              onetime: times,
            };
            self.countData('onetime', times);
            self.changeChart(onetimeChart, 'onetime');
            self.changeTable(times, 'onetime'); // 单次使用时长折线图
          }));

          const time = dateToTime(bus.selectedDate);
          const days = self.getDays(bus.selectedDate[1]) + 1;
          // 开始请求并计算周活跃，月活跃
          self.getLaunch('week', time + days, 0, -time, false);
          self.getLaunch('month', time + days, 0, -time, false);
        }));
      },
      /**
       * 绘制图表
       * @param  {[Object]} chartData [对应的图表对象]
       * @param  {[String]} str       [图表标示]
       */
      changeChart(chartData, str) {
        const ref = this.$refs[str];
        if (ref && ref.setChartsData) {
          this[str].show = true;
          ref.setChartsData(chartData, 'day', str);
        }
      },
      /**
       * 表格渲染
       * @param  {[Array]} data [表格数据]
       * @param  {[String]} user [表格对应列标示]
       */
      changeTable(data, user) {
        const trendTable = this.$refs['trend-table'];

        // 获取表格 saveTableData 即已渲染表格数据
        const tabledata = trendTable.saveTableData ? JSON.parse(trendTable.saveTableData) : [];
        // 将数据添加到 saveTableData 中
        for (let i = 0; i < tabledata.length; i++) {
          for (let j = 0; j < data.length; j++) {
            if (data[j].day === tabledata[i].day) {
              if (user === 'onetime') {
                tabledata[i][user] = numberToTime(data[j][user]);
              } else {
                tabledata[i][user] = data[j][user];
              }
            }
          }
        }
        // 将数据渲染表格中
        trendTable.saveTableData = JSON.stringify(tabledata);
        trendTable.changeData = tabledata;
        trendTable.tableData = trendTable.mockTableData(1, tabledata);
      },
      // 导出数据
      exportData() {
        const trendTable = this.$refs['trend-table'];
        const name = ln[bus.lang].trend.overview.title;
        trendTable.exportTable(name);
      },
      // 清空数据
      clearData() {
        this.newuser = {
          show: false,
          userTotal: '--',
          watchTotal: '--',
          userAverage: '--',
          watchAverage: '--',
        };
        this.launchuser = {
          show: false,
          userTotal: '--',
          watchTotal: '--',
          userAverage: '--',
          watchAverage: '--',
        };
        this.week = {
          show: false,
          userAverage: '--',
        };
        this.month = {
          show: false,
          userAverage: '--',
        };
        this.startup = {
          show: false,
          userAverage: '--',
        };
        this.onetime = {
          show: false,
          userAverage: '--',
        };
        this.trendTable = {
          show: false,
        };
        this.initUser = 'newuser';
        this.monthTotal = 0;
        this.weekTotal = 0;
        this.weekChartData = [];
        this.monthChartData = [];
      },
      // 日期转换
      setDateToTime() {
        const startTime = Date.parse(new Date(bus.selectedDate[0]));
        const endTime = Date.parse(new Date(bus.selectedDate[1]));
        const day = ((endTime - startTime) / 1000 / 60 / 60 / 24);
        return day;
      },
      /**
       * 切换日期
       * @param  {[String]} date [选择的日期]
       */
      changeContrast(date) {
        const startTime = Date.parse(new Date(date));
        const endTime = Date.parse(new Date());
        const number = ((endTime - startTime) / 1000 / 60 / 60 / 24);
        this.changeDateNumber = number;
      },
      /**
       * 确认日期
       * @param  {[Number]} num [选择的结束日期距离今天 num天]
       */
      contrastDate(num) {
        TDAPP.onEvent('用户趋势-对比时段');// eslint-disable-line
        const date = [];
        if (num) {
          date[0] = bus.getDay(-this.setDateToTime() - num); // 起始日期
          date[1] = bus.getDay(-num); // 结束日期
        } else {
          date[0] = bus.getDay(-this.changeDateNumber);
          date[1] = bus.getDay(this.setDateToTime() - this.changeDateNumber);
        }
        if (new Date(date[0]) < new Date('2018-01-01') && new Date(date[1]) >= new Date('2018-01-01')) {
          this.$Message.destroy();
          this.$Message.warning({
            content: '不支持跨2017、2018的跨年对比',
          });
          this.datePickerOpen = false;
          return;
        }
        this.selectedDate = `${date[0]}~${date[1]}`;
        this.openContrast(date);
        // if (window.auryc) {
        //   auryc.track('用户趋势-对比时段');// eslint-disable-line
        // }
        this.datePickerOpen = false;
      },
      // 对比日期的数据请求
      openContrast(date) {
        const self = this;
        const dateTemp = {
          selectedDate: date,
        };
        // todo 是否需要加载watch数据
        const newuserUrl = self.watchDataShow ? [
          self.getMetrics('newuser', dateTemp),
          self.getMetrics('newuser', dateTemp, '8'),
        ] : [self.getMetrics('newuser', dateTemp)];
        const launchuserUrl = self.watchDataShow ? [
          self.getMetrics('launchuser', dateTemp),
          self.getMetrics('launchuser', dateTemp, '8'),
        ] : [self.getMetrics('launchuser', dateTemp)];
        const strArr = ['newuser', 'launchuser', 'week', 'month', 'startup', 'onetime'];
        strArr.forEach((str) => {
          self.$refs[str].spinShow = true;
        });
        // console.log('----------对比新增数据---------');
        axios.all(newuserUrl).then(axios.spread((newRes, newWatchRes) => {
          if (self.openDiff && self.selectedDate) self.diffChartData(newRes, 'newuser', newWatchRes);
          // console.log('----------对比活跃数据---------');
          axios.all(launchuserUrl).then(axios.spread((launch, launchWatchRes) => {
            if (self.openDiff && self.selectedDate) self.diffChartData(launch, 'launchuser', launchWatchRes);
          }));
          // console.log('----------对比启动次数---------');
          self.getMetrics('startup', dateTemp).then((startRes) => {
            if (self.openDiff && self.selectedDate) self.diffChartData(startRes, 'startup');
          });
          // console.log('----------对比单次使用时长---------');
          axios.all([
            self.getMetrics('startup', dateTemp), // 启动次数
            self.getMetrics('usetime', dateTemp), // 使用时长
          ]).then(axios.spread((start, timeRes) => {
            const times = [];
            for (let i = 0; i < start.length; i++) {
              for (let j = 0; j < timeRes.length; j++) {
                const averageTime = start[i].startup === 0 ?
                  0 : Math.round(timeRes[j].usetime / start[i].startup);
                if (timeRes[j].day === start[i].day) {
                  times[i] = {
                    day: start[i].day,
                    onetime: averageTime,
                  };
                }
              }
            }
            if (self.openDiff && self.selectedDate) self.diffChartData(times, 'onetime');
          }));
          const time = dateToTime(dateTemp.selectedDate);
          const days = self.getDays(dateTemp.selectedDate[1]) + 1;
          // console.log('----------对比周活跃、月活跃---------');
          self.getLaunch('week', time + days, 0, -time, true);
          self.getLaunch('month', time + days, 0, -time, true);
        }));
      },
      diffChartData(data, str, watchData) {
        this.$refs[str].spinShow = false;
        const self = this;
        const chartTime = [];
        const value = [];
        const valueNewuserWatch = [];
        for (let i = 0; i < data.length; i++) {
          if (chartTime.indexOf(data[i].time) <= -1) {
            chartTime[i] = data[i].day;
          }
          value[i] = data[i][str];
          if (self.watchDataShow && (str === 'newuser' || str === 'launchuser')) {
            valueNewuserWatch[i] = watchData[i][str];
          }
        }
        const strDiff = `${ln[bus.lang].chartview[str].name}${ln[bus.lang].chartview.diff}`;
        const chartSeries = {
          type: 'line',
          data: value,
          smooth: true,
          showSymbol: value.length === 1,
          name: strDiff,
          xAxisIndex: 1,
        };
        if (self.watchDataShow && (str === 'newuser' || str === 'launchuser')) {
          const strWatchDiff = `${ln[bus.lang].chartview[str].watch}${ln[bus.lang].chartview.diff}`;

          const chartWatchSeries = {
            type: 'line',
            data: valueNewuserWatch,
            smooth: true,
            showSymbol: valueNewuserWatch.length === 1,
            name: strWatchDiff,
            xAxisIndex: 3,
          };
          self.$refs[str].chartData.series[0].areaStyle = {
            normal: {
              opacity: 0,
            },
          };
          self.$refs[str].chartData.series[2] = chartSeries;
          self.$refs[str].chartData.series[3] = chartWatchSeries;
          self.$refs[str].lineName[2] = strDiff;
          self.$refs[str].lineName[3] = strWatchDiff;
          self.$refs[str].indexName = chartTime;
          self.$refs[str].resizeChart();
        } else {
          self.$refs[str].chartData.series[0].areaStyle = {
            normal: {
              opacity: 0,
            },
          };
          self.$refs[str].chartData.series[1] = chartSeries;
          self.$refs[str].lineName[1] = strDiff;
          self.$refs[str].indexName = chartTime;
          self.$refs[str].resizeChart();
        }
      },
      // 取消对比
      clearContrast() {
        const self = this;
        self.selectedDate = '';
        self.datePickerOpen = false;
        self.openDiff = false;
        const strArr = ['newuser', 'launchuser', 'week', 'month', 'startup', 'onetime'];
        strArr.forEach((str) => {
          if (self.$refs[str].chartData.series && self.$refs[str].chartData.series.length === 2
            && !self.watchDataShow) {
            self.$refs[str].chartData.series[0].areaStyle.normal.opacity = 0.1;
            self.$refs[str].chartData.series.pop();
            self.$refs[str].lineName.pop();
            self.$refs[str].resizeChart();
          } else if (self.$refs[str].chartData.series
            && self.$refs[str].chartData.series.length === 4) {
            self.$refs[str].chartData.series[0].areaStyle.normal.opacity = 0.1;
            self.$refs[str].chartData.series = self.$refs[str].chartData.series.slice(0, 2);
            self.$refs[str].lineName.pop();
            self.$refs[str].resizeChart();
          }
        });
      },
      // 显示日历组件
      toggleDatePicker() {
        this.datePickerOpen = !this.datePickerOpen;
      },
      // 对比时间段隐藏清除图表对比
      diffClear() {
        if (!this.openDiff) this.clearContrast();
      },
    },
  };
</script>
